import { apiFetch } from '@/api'
import { Parameter } from '@/interfaces'

export const fetchVersions = async (): Promise<Parameter> =>
  (await apiFetch('/parameters/versions', { method: 'GET' })).data
